import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import MyRoute from './Route';

import AppNavbar from '../components/AppNavbar';

import splash from '../pages/splash';
import login from '../pages/login';
import user from '../pages/user';
import user_card from '../pages/user_card';
import token from '../pages/token';
import token_card from '../pages/token_card';
import loginlog from '../pages/loginlog';
import client from '../pages/client';
import client_card from '../pages/client_card';
import prospects from '../pages/prospects';
import visitors from '../pages/visitors';
import vente from '../pages/vente/normale';
import venteAssociation from '../pages/vente/association';
import bien_list from '../pages/bien_list';
import vente_list from '../pages/vente_list';
import clientvente_list from '../pages/clientvente_list';
import vente_list_charge from '../pages/vente_list_charge';
import uservente_list from '../pages/uservente_list';
import vente_by_charge_list from '../pages/vente_by_charge_list';
import vente_minute from '../pages/vente_minute';
// import vente_by_charge_list_2 from '../pages/vente_by_charge_list_2';
import vente_pp from '../pages/vente_pp';
import summary_by_project from '../pages/by_project';
import summary_by_charge from '../pages/by_charge';
import commission from '../pages/commission';
import bulletin_list from '../pages/bulletin_list';
import bulletin_commission from '../pages/bulletin';
import commission_payment from '../pages/commission_payment';
import chart from '../pages/chart';
import consultation from '../pages/consultation';
import bien_card from '../pages/bien_card';
import divisions from '../pages/divisions';
import doa from '../pages/doa';
import dr from '../pages/dr';
import addEncaissement from '../pages/addEncaissement';
import repEncaissement from '../pages/remplacement';
import plan from '../pages/plan';
import ptfV from '../pages/ptf_v';
import ptfAnpv from '../pages/ptf_anpv';
import ptfDelay from '../pages/ptf_delay';
import ptfBv from '../pages/ptf_bv';
import enc_receptionnes_list from '../pages/enc_receptionnes_list';
import enc_verses_list from '../pages/enc_verses_list';
import ptfS from '../pages/ptf_s';
import ptfCompta from '../pages/ptf_compta';
// import ptfC from '../pages/ptf_c';
import ei from '../pages/ei';
import encaissement_replacement from '../pages/encaissement_replacement';
import encaissement_list from '../pages/encaissement_list';
import userencaissement_list from '../pages/userencaissement_list';
import encaissement_notaire from '../pages/encaissement_notaire';
import planDev from '../pages/plan_dev';
import desistement from '../pages/dt_desistement';
import transfert from '../pages/dt_transfert';
import changementBien from '../pages/dt_changement_bien';
import goal0 from '../pages/goal0';
import goal from '../pages/goal';
import budget0 from '../pages/budget0';
import budget from '../pages/budget';
import budget_charge from '../pages/budget_charge';
import goal_charge from '../pages/goal_charge';
import enc_rapprochement from '../pages/enc_rapprochement';
import enc_manual_rapprochement from '../pages/enc_manual_rapprochement';
import enc_rep_req_list from '../pages/enc_rep_req_list';
import recu_req_list from '../pages/recu_req_list';
import dtWebmaster from '../pages/dt_webmaster';
import notification from '../pages/notification';
import superadmin from '../pages/superadmin';
import construction from '../pages/construction';
import Suggestions from '../components/Suggestions';
import UnpaidChecksPopup from '../components/WarningPopup';
import testplan from '../pages/testplan';
import test from '../pages/test';

import { Provider } from 'react-redux';
import store from '../flux/store';
import { connect } from 'react-redux';
import { PRIVILEGE } from '../types/privileges'
import { IAuthReduxProps, IAuthComponent } from '../types/interfaces';

// import Sidebar from '../components/sidebar';
import "react-pro-sidebar/dist/css/styles.css";
import ProSidebar from '../components/sidebar/index';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
import 'react-month-picker/css/month-picker.css';
// import 'react-perfect-scrollbar/dist/css/styles.css';
import './styles.css';

const Routes = ({ auth }: IAuthComponent) => {

	const LoginContainer = () => (
		<Provider store={store}>
			{/* <Route exact path="/" render={() => <Redirect to="/connexion" />} /> */}
			<Route path="/connexion" exact component={login} />
			<Route path="/connexion/:redirect" exact component={login} />
		</Provider>
	)
	
	
	const DefaultContainer = ({location, history}) => (
		<>
			<Provider store={store}>
				<AppNavbar />
				{/* <Sidebar location={location} history={history} /> */}
				<ProSidebar location={location} history={history} />
				<main className="sideBarMain main">
					<Switch>
						<MyRoute path="/" exact component={splash} />
						<MyRoute path="/utilisateurs" component={user} privilege={PRIVILEGE.USERS} />
						<MyRoute path="/gestion_utilisateur/:id" component={user_card} privilege={PRIVILEGE.USERS} />
						<MyRoute path="/parc_informatique" component={token} privilege={PRIVILEGE.PARC_INFORMATIQUE} />
						<MyRoute path="/fiche_token/:id" component={token_card} privilege={PRIVILEGE.PARC_INFORMATIQUE} />
						<MyRoute path="/journal_connexions" component={loginlog} privilege={PRIVILEGE.PARC_INFORMATIQUE} />
						<MyRoute path="/clients" component={client} atLeastOnePrivilege={[PRIVILEGE.EDIT_CLIENTS, PRIVILEGE.LIST_CLIENTS]} />
						<MyRoute path="/fiche_client/:id" component={client_card} atLeastOnePrivilege={[PRIVILEGE.EDIT_CLIENTS, PRIVILEGE.LIST_CLIENTS]} />
						<MyRoute path="/prospects" component={prospects} privilege={PRIVILEGE.ADD_CLIENT} />
						<MyRoute path="/visiteurs" component={visitors} atLeastOnePrivilege={[PRIVILEGE.ADD_VISITORS, PRIVILEGE.LIST_VISITORS]} />
						<MyRoute path="/vente" component={vente} privilege={PRIVILEGE.VENTE_NORMALE} />
						<MyRoute path="/association" component={venteAssociation} privilege={PRIVILEGE.VENTE_ASSOCIATION} />
						<MyRoute path="/liste_biens" component={bien_list} privilege={PRIVILEGE.LIST_BIEN} />
						<MyRoute path="/liste_ventes" component={vente_list} privilege={PRIVILEGE.LIST_VENTES} />
						<MyRoute path="/liste_clients_ventes" component={clientvente_list} privilege={PRIVILEGE.LIST_VENTES} />
						<MyRoute path="/modification_charges_biens" component={vente_list_charge} privilege={PRIVILEGE.EDIT_CHARGE} />
						<MyRoute path="/mes_ventes" component={uservente_list} privilege={PRIVILEGE.MY_VENTES} />
						<MyRoute path="/ventes_minutes" component={vente_minute} privilege={PRIVILEGE.EXPEDITION_MINUTE} />
						<MyRoute path="/ventes_par_charge" exact component={vente_by_charge_list} privilege={PRIVILEGE.MY_VENTES} />
						<MyRoute path="/ventes_par_charge/:project/:user" exact component={vente_by_charge_list} privilege={PRIVILEGE.MY_VENTES} />
						<MyRoute path="/total_pourcentages_parts" exact component={vente_pp} privilege={PRIVILEGE.CONSULTATION}/*POURCENTAGES_PARTS*/ />
						<MyRoute path="/total_pourcentages_parts/:project/:user" exact component={vente_pp} privilege={PRIVILEGE.CONSULTATION}/*POURCENTAGES_PARTS*/ />
						{/* <MyRoute path="/ventes_par_charge_2" component={vente_by_charge_list_2} privilege={PRIVILEGE.VENTES_BY_CHARGE} /> */}
						<MyRoute path="/resume_projets" component={summary_by_project} privilege={PRIVILEGE.SUMMARY_PROJECT} />
						<MyRoute path="/resume_charges" exact component={summary_by_charge} privilege={PRIVILEGE.SUMMARY_PROJECT}/*ACCESS_ALL_USERS*/ />
						<MyRoute path="/resume_charges/:project" exact component={summary_by_charge} privilege={PRIVILEGE.SUMMARY_PROJECT}/*ACCESS_ALL_USERS*/ />
						<MyRoute path="/commissions" component={commission} atLeastOnePrivilege={[PRIVILEGE.OWN_GOAL, PRIVILEGE.COMMISSIONS_PAGE]} />
						<MyRoute path="/bulletins_commissions" component={bulletin_list} privilege={PRIVILEGE.COMMISSIONS_PAGE} />
						<MyRoute path="/bulletin_commission/:id" component={bulletin_commission} privilege={PRIVILEGE.OTHERS_COMMISSIONS} />
						<MyRoute path="/paiement_commissions" component={commission_payment} privilege={PRIVILEGE.VALIDATE_COMMISSIONS} />
						<MyRoute path="/chart" component={chart} privilege={PRIVILEGE.WEBMASTER} />
						<MyRoute path="/consultation" exact component={consultation} privilege={PRIVILEGE.CONSULTATION} />
						<MyRoute path="/consultation/:id" exact component={consultation} privilege={PRIVILEGE.CONSULTATION} />
						<MyRoute path="/consultation/bien/:bienId" exact component={consultation} privilege={PRIVILEGE.CONSULTATION} />
						<MyRoute path="/fiche_bien/:id" component={bien_card} privilege={PRIVILEGE.CONSULTATION} />
						<MyRoute path="/demandes_ouverture_association" component={doa} privilege={PRIVILEGE.ASSOCIATION_ADMIN} />
						<MyRoute path="/demandes_repartition" component={divisions} privilege={PRIVILEGE.APPROVE_DIVISION} />
						<MyRoute path="/demandes_remise" component={dr} privilege={PRIVILEGE.REMISE_ADMIN}/*TODO*/ />
						<MyRoute path="/nouvel_encaissement" exact component={addEncaissement} privilege={PRIVILEGE.ADD_ENCAISSEMENT} />
						<MyRoute path="/nouvel_encaissement/:id" exact component={addEncaissement} privilege={PRIVILEGE.ADD_ENCAISSEMENT} />
						<MyRoute path="/nouvel_encaissement/:id/:ass" exact component={addEncaissement} privilege={PRIVILEGE.ADD_ENCAISSEMENT} />
						<MyRoute path="/remplacement_encaissement" exact component={repEncaissement} privilege={PRIVILEGE.ADD_ENCAISSEMENT} />
						<MyRoute path="/remplacement_encaissement/:id" exact component={repEncaissement} privilege={PRIVILEGE.ADD_ENCAISSEMENT} />
						<MyRoute path="/remplacement_encaissement/:id/:ass" exact component={repEncaissement} privilege={PRIVILEGE.ADD_ENCAISSEMENT} />
						<MyRoute path="/plan" component={plan} privilege={PRIVILEGE.PLAN_MASSE} />
						{/* <MyRoute path="/1plan" component={plan1} privilege={PRIVILEGE.PLAN_MASSE} />
						<MyRoute path="/2plan" component={plan2} privilege={PRIVILEGE.PLAN_MASSE} />
						<MyRoute path="/3plan" component={plan3} privilege={PRIVILEGE.PLAN_MASSE} />
						<MyRoute path="/4plan" component={plan4} privilege={PRIVILEGE.PLAN_MASSE} /> */}
						<MyRoute path="/plan_dev" component={planDev} privilege={PRIVILEGE.PLAN_MASSE} />
						<MyRoute path="/encaissements_a_valider" component={ptfV} privilege={PRIVILEGE.VALIDATION_ENC} />
						<MyRoute path="/encaissements_a_ne_pas_verser" component={ptfAnpv} privilege={PRIVILEGE.VALIDATION_ENC} />
						<MyRoute path="/encaissements_a_prolonger" component={ptfDelay} privilege={PRIVILEGE.VALIDATION_ENC} />
						<MyRoute path="/portefeuille_bureau_vente" component={ptfBv} privilege={PRIVILEGE.PORTEFEUILLE_BUREAU_VENTE} />
						<MyRoute path="/encaissements_receptionnes" component={enc_receptionnes_list} privilege={PRIVILEGE.LIST_ENCAISSEMENTS} />
						<MyRoute path="/encaissements_verses" component={enc_verses_list} privilege={PRIVILEGE.LIST_ENCAISSEMENTS} />
						<MyRoute path="/portefeuille_siege" component={ptfS} privilege={PRIVILEGE.PORTEFEUILLE_SIEGE} />
						<MyRoute path="/envoi_a_la_comptabilite" component={ptfCompta} privilege={PRIVILEGE.SEND_ENC_TO_COMPTA} />
						{/* <MyRoute path="/portefeuille_comptabilite" component={ptfC} privilege={PRIVILEGE.PORTEFEUILLE_COMPTA} isUnderConstruction /> */}
						<MyRoute path="/rapprochement_encaissements" component={enc_rapprochement} privilege={PRIVILEGE.RAPPROCHEMENT_ENC} />
						<MyRoute path="/rapprochement_manuel" component={enc_manual_rapprochement} privilege={PRIVILEGE.RAPPROCHEMENT_ENC} />
						<MyRoute path="/encaisses_impayes" component={ei} privilege={PRIVILEGE.ENCAISSE_IMPAYE} />
						<MyRoute path="/remplacement_cheques" component={encaissement_replacement} privilege={PRIVILEGE.REPLACE_ENCAISSEMENT} />
						<MyRoute path="/encaissements" component={encaissement_list} privilege={PRIVILEGE.LIST_ENCAISSEMENTS} />
						<MyRoute path="/mes_encaissements" component={userencaissement_list} privilege={PRIVILEGE.MY_VENTES} />
						<MyRoute path="/encaissements_notaire" component={encaissement_notaire} privilege={PRIVILEGE.LIST_ENCAISSEMENTS_NOTAIRE} />
						<MyRoute path="/desistement" component={desistement} atLeastOnePrivilege={[PRIVILEGE.DESISTEMENT, PRIVILEGE.FICHE_DESISTEMENT]} />
						<MyRoute path="/transfert" component={transfert} atLeastOnePrivilege={[PRIVILEGE.TRANSFERT, PRIVILEGE.FICHE_DESISTEMENT]} />
						<MyRoute path="/changement_bien" component={changementBien} atLeastOnePrivilege={[PRIVILEGE.CHANGEMENT_BIEN, PRIVILEGE.FICHE_DESISTEMENT]} />
						<MyRoute path="/objectifs0" component={goal0} privilege={PRIVILEGE.LIST_GOALS} />
						<MyRoute path="/objectifs" component={goal} atLeastOnePrivilege={[PRIVILEGE.EDIT_GOALS, PRIVILEGE.EDIT_BUDGETS]} />
						<MyRoute path="/budget0" component={budget0} privilege={PRIVILEGE.LIST_BUDGETS} />
						<MyRoute path="/budget" component={budget} atLeastOnePrivilege={[PRIVILEGE.LIST_GOALS, PRIVILEGE.LIST_BUDGETS]} />
						<MyRoute path="/objectif_charges_biens" component={budget_charge} privilege={PRIVILEGE.LIST_GOALS} />
						<MyRoute path="/objectif_par_charge" exact component={goal_charge} privilege={PRIVILEGE.OWN_GOAL} />
						<MyRoute path="/objectif_par_charge/:project/:user" exact component={goal_charge} privilege={PRIVILEGE.OWN_GOAL} />
						<MyRoute path="/demandes_remplacements_cheques" component={enc_rep_req_list} privilege={PRIVILEGE.REPLACE_ENCAISSEMENT} />
						<MyRoute path="/demandes_recus" component={recu_req_list} privilege={PRIVILEGE.WEBMASTER} />
						<MyRoute path="/dt" component={dtWebmaster} privilege={PRIVILEGE.WEBMASTER} />
						<MyRoute path="/notifications" component={notification} privilege={PRIVILEGE.MANAGE_NOTIFICATIONS} />
						<MyRoute path="/webmasta" component={superadmin} privilege={PRIVILEGE.WEBMASTER} />
						<MyRoute path="/construction" component={construction} />
						<MyRoute path="/testplan" component={testplan} />
						<MyRoute path="/test" component={test} loginNotNeeded />
						<Route render={() => <Redirect to="/" />} />
					</Switch>
				</main>
				<UnpaidChecksPopup />
				<p className="madeWithBy" style={{}}>&nbsp; . &nbsp;</p>
				{/* Made with ♥ by Ayoub Laazazi */}
				{/* <Suggestions/> */}
			</Provider>
		</>
	)

	return (
		<>
			<Switch>
				<Route path="/connexion" component={LoginContainer} />
				<Route component={DefaultContainer} />
				{/* <MyRoute path="/connexion" exact component={login} name="connexion" />
				<MyRoute path="/dd" component={page1} isPrivate name="dd" />
				<Route render={() => <Redirect to="/dd" />} /> */}
			</Switch>
		</>
	);
}

const mapStateToProps = (state: IAuthReduxProps) => ({
	auth: state.auth,
	error: state.error
});

// export default connect(mapStateToProps, null)(Routes);
export default Routes;